import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";
import { ProjectStatus } from "$types/ProjectStatus";
import { PROJECT_STATUS_LABELS } from "$utils/typeConstants/Project";
import { StatusBadge } from "$components";

type Props = {
  disabled?: boolean;
  status: ProjectStatus;
};

function ProjectStatusBadge({
  disabled = false,
  status = ProjectStatus.IN_PROGRESS,
}: Props) {
  const classes = useStyles();
  let text: string;
  let className: string;
  switch (status) {
    case ProjectStatus.IN_PROGRESS:
      text = PROJECT_STATUS_LABELS[ProjectStatus.IN_PROGRESS];
      className = disabled ? classes.disabled : classes.progress;
      break;
    case ProjectStatus.DONE:
      text = PROJECT_STATUS_LABELS[ProjectStatus.DONE];
      className = disabled ? classes.disabled : classes.done;
      break;
    default:
      console.error(`Invalid variant / project status for Badge: ${status}`);
  }
  return <StatusBadge text={text} className={className} />;
}

export default ProjectStatusBadge;

const useStyles = createUseStyles(() => ({
  progress: {
    backgroundColor: theme.color.blueLight,
  },
  done: {
    backgroundColor: theme.color.green,
  },
  disabled: {
    backgroundColor: theme.color.gray3,
  },
}));
